import {sweetAPI} from 'app/store/sweet-api';
import {showLoadingBar, showMessages} from 'app/store/sweet-api/utils';
import {REACTIONS_API} from 'app/urls';
import {gt} from 'app/utils/i18n';
import {COMMENT_TAG, REACTION_TAG} from 'app/utils/rtk-tags';

import type {CommentReactionTypeWithTone} from 'sweet-types';

export type ReactionProps = {
  content_type: 'commentwithmeta';
  object_id: number;
  name: CommentReactionTypeWithTone;
};

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [REACTION_TAG, COMMENT_TAG]})
  .injectEndpoints({
    endpoints: (build) => ({
      addReaction: build.mutation<unknown, ReactionProps>({
        query: (body) => ({
          url: REACTIONS_API,
          method: 'POST',
          body: {...body, add: true},
        }),
        invalidatesTags: () => [
          {type: REACTION_TAG, id: 'list'},
          {type: COMMENT_TAG, id: 'list'},
        ],
        onQueryStarted: (args, api) => {
          showLoadingBar(args, api);
          showMessages({
            onError: () => gt('Unable to add reaction.'),
          })(args, api);
        },
      }),
      removeReaction: build.mutation<unknown, ReactionProps>({
        query: (body) => ({
          url: REACTIONS_API,
          method: 'POST',
          body: {...body, add: false},
        }),
      }),
    }),
  });

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {
  useAddReactionMutation: useAddReaction,
  useRemoveReactionMutation: useRemoveReaction,
} = extendedAPI;
